import { Div, Text } from "atomize"
import { theme } from "./settings/config"
import { useContext, useState } from "react"
import Divider from "./atoms/Divider"
import { motion } from "framer-motion"
import { playersContext } from "./providers/players.provider"
import { profileContext } from "./providers/profile.provider"
import Player from "./Player.js"
import { faUserPlus } from "@fortawesome/free-solid-svg-icons"
import { modalContext } from "./providers/modal.provider"
import { schoolContext } from "./providers/school.provider"
import EmptyState from "./atoms/EmptyState"

function PlayersList() {
	const { players, searchedPlayers, showArchived, loadedSchool } = useContext(playersContext)
	const { coach, loading: profileLoading } = useContext(profileContext)
	const { getSelectedSchool, selectedSchool, loading: schoolLoading } =
		useContext(schoolContext)
	const Modal = useContext(modalContext)

	const [isOpen, setOpenPlayer] = useState(null)

	// Stesso ragionamento della lista lezioni: si risponde solo quando gli
	// allievi di questo circolo sono arrivati davvero, non quando qualcuno
	// dichiara di non stare caricando.
	const isBooting =
		profileLoading ||
		!coach ||
		schoolLoading ||
		(Boolean(getSelectedSchool()) && loadedSchool !== selectedSchool)

	const handleOpenPlayerActions = playerID => {
		isOpen === null || isOpen !== playerID ? setOpenPlayer(playerID) : setOpenPlayer(null)
	}

	return (
		<motion.div
			animate={{ y: [20, 0] }}
			transition={{
				ease: [0.04, 0.62, 0.23, 0.98],
				duration: 0.4,
			}}>
			<Div
				bg={theme.colors.surface}
				m={{ t: "0.5rem" }}
				p={{ y: "1rem" }}
				rounded={theme.rounded["20px"]}
				shadow={theme.shadows.accent}>
				{isBooting ? (
					<Text textSize="subheader" textAlign="center" p="0.5rem 1rem">
						Sto cercando i giocatori... 🧐
					</Text>
				) : players?.length > 0 ? (
					players?.map((player, i) => (
						<Div key={i}>
							<Player
								playerData={player}
								playerIndex={i}
								isOpen={isOpen === player.playerID}
								modalView={false}
								handleOpenPlayerActions={handleOpenPlayerActions}
							/>
							{i < players.length - 1 && <Divider w="0.25rem solid" />}
						</Div>
					))
				) : searchedPlayers !== "" || showArchived ? (
					<Text textSize="subheader" textAlign="center" p="0.5rem 1rem">
						{searchedPlayers !== ""
							? "Nessun allievo trovato con questa ricerca 🧐"
							: "Non hai allievi archiviati 😌"}
					</Text>
				) : (
					<EmptyState
						icon={faUserPlus}
						title="Ancora nessun allievo"
						text="Puoi aggiungerli qui con tutti i dati, oppure scriverne il nome mentre segni una lezione: l'allievo nasce da solo e lo completi dopo."
						actionText="Aggiungi un allievo"
						color={theme.colors.accent}
						action={() => getSelectedSchool() && Modal.open("newPlayer")}
						secondaryText="Ne hai già un elenco? Importalo"
						secondaryAction={() => getSelectedSchool() && Modal.open("importPlayers")}
					/>
				)}
			</Div>
		</motion.div>
	)
}

export default PlayersList
